import { AlertTriangle } from 'lucide-react'
import { OnScreenModal } from '@/components/ui/OnScreenModal'
import {
  primaryEntityActionButtonClass,
  secondaryEntityActionButtonClass,
} from '@/components/ui/entityActionButtonClasses'

export interface EvictionLawsuitWarningModalProps {
  isOpen: boolean
  onContinue: () => void
  onCancel: () => void
}

export function EvictionLawsuitWarningModal({
  isOpen,
  onContinue,
  onCancel,
}: EvictionLawsuitWarningModalProps) {
  return (
    <OnScreenModal
      isOpen={isOpen}
      title="Document Upload Warning"
      onClose={onCancel}
      maxWidth="max-w-lg"
      headerVariant="iconTitle"
      titleIcon={
        <div className="rounded-full bg-amber-100 p-2">
          <AlertTriangle className="text-amber-600" size={24} />
        </div>
      }
      footer={
        <div className="flex w-full gap-3">
          <button type="button" onClick={onCancel} className={`${secondaryEntityActionButtonClass} flex-1`}>
            Upload Later
          </button>
          <button type="button" onClick={onContinue} className={`${primaryEntityActionButtonClass} flex-1`}>
            Upload Eviction Lawsuit
          </button>
        </div>
      }
    >
      <div className="space-y-4">
        <div className="rounded-lg border-2 border-amber-300 bg-amber-50 p-4">
          <p className="mb-3 text-sm font-semibold text-amber-900">
            Have you uploaded any of the following documents?
          </p>
          <ul className="ml-4 space-y-1.5 text-sm text-amber-900">
            {[
              'Notice of Service',
              'Summons',
              'Notice of Hearing',
              'Judgement/Order',
              'Stipulation Agreement',
              'Default Stipulation',
              'Writ of Ejectment',
            ].map((item) => (
              <li key={item} className="flex items-start gap-2">
                <span className="mt-0.5 text-amber-600">•</span>
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>

        <p className="text-sm text-gray-700">
          If you are attempting to upload any of these documents, please cancel this operation and upload the
          eviction lawsuit for maximum reimbursements. Alternate court issued documents are accepted for a
          reduced reimbursement. To proceed with alternate court issued documents, cancel this operation, and
          answer &apos;yes&apos; to the next question. Please contact Property Support at
          propertysupport@libertyrent.com for additional guidance.
        </p>
      </div>
    </OnScreenModal>
  )
}
